import { all, put, takeEvery } from "redux-saga/effects";

import {
  // notifyError,
  notifySuccess,
} from "../../../actions/notify";
import { CALL_LOCAL_RECORDING_UPLOAD_COMPLETION, CALL_LOCAL_RECORDING_UPLOAD_FAILED } from "../../../actions/types";
import { sleep } from "../../../../components/utils/util";

export function* localRecordingNotify() {
  yield all([
    takeEvery(CALL_LOCAL_RECORDING_UPLOAD_COMPLETION, function* () {
      // I feel bad about this. Forgive me, future self, for I have sinned
      // Note: actually doing this because firefox kills network requests before killing js,
      // so we show upload failures when you reload the page, and this is a dumb, hacky, simple, functional workaround
      yield sleep(500);
      yield put(notifySuccess("Your locally recorded media has uploaded."));
    }),
    takeEvery(CALL_LOCAL_RECORDING_UPLOAD_FAILED, function* () {
      // 🦄
      yield sleep(500);
      // yield put(notifyError("Your locally recorded media failed to upload."));
    }),
  ]);
}
